import { ComputedDatum } from '@nivo/pie';
import * as React from 'react';
import classNames from 'classnames';
import Text from '../Text';

import styles from './ChartTooltip.module.scss';

export interface TooltipDatum {
  id: string;
}

export interface Props<T>
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'> {
  datum: Partial<ComputedDatum<T>>;
  useFormattedValue?: boolean;
}

/**
 * <ChartTooltip> component
 */
export const ChartTooltip = <T extends TooltipDatum>({
  className,
  datum,
  useFormattedValue,
  ...htmlElementProps
}: React.PropsWithChildren<Props<T>>): React.ReactElement => (
  <div
    className={classNames(styles.tooltip, className)}
    role="tooltip"
    {...htmlElementProps}
  >
    <span
      className={styles.dot}
      style={{ backgroundColor: datum.color ?? 'var(--q24-color-primary)' }}
    />

    <Text as="span" size="sm2">
      {`${datum.label}:`}&nbsp;
    </Text>
    <Text as="span" size="sm2" weight="bold">{`${
      useFormattedValue ? datum.formattedValue : datum.value
    }`}</Text>
  </div>
);

export default ChartTooltip;
